import i18next from 'i18next'

const welcomeEmailImageInputPropsMinSize = {
  width: 944,
  height: 400,
}

export const welcomeEmailImageInputProps = {
  title: i18next.t('Quote image'),
  entityName: 'image',
  wrapperClassName: 'welcome-email-quote-image',
  minSize: welcomeEmailImageInputPropsMinSize,
  cropper: {
    outputWidth: welcomeEmailImageInputPropsMinSize.width,
    outputHeight: welcomeEmailImageInputPropsMinSize.height,
    renderWidth: welcomeEmailImageInputPropsMinSize.width * 0.5,
    renderHeight: welcomeEmailImageInputPropsMinSize.height * 0.5,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

const badgeImagePropsMinSize = {
  width: 240,
  height: 240,
}

export const badgeImageProps = {
  title: i18next.t('Badge'),
  entityName: i18next.t('badge'),
  minSize: badgeImagePropsMinSize,
  cropper: {
    outputWidth: badgeImagePropsMinSize.width,
    outputHeight: badgeImagePropsMinSize.height,
    renderWidth: badgeImagePropsMinSize.width * 0.5,
    renderHeight: badgeImagePropsMinSize.height * 0.5,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const promoPageSettingsImageInputMinSize = {
  width: 488,
  height: 274,
}

export const promoPageSettingsImageInputProps = {
  title: 'Image',
  entityName: 'image',
  minSize: promoPageSettingsImageInputMinSize,
  cropper: {
    outputWidth: 488,
    outputHeight: 274,
    renderWidth: promoPageSettingsImageInputMinSize.width - promoPageSettingsImageInputMinSize.width * 0.1,
    renderHeight: promoPageSettingsImageInputMinSize.height - promoPageSettingsImageInputMinSize.height * 0.1,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const orgInactiveNotificationsImageMinSize = {
  width: 500,
  height: 500,
}

export const orgInactiveNotificationsImageInputProps = {
  title: 'Image',
  entityName: 'image',
  minSize: orgInactiveNotificationsImageMinSize,
  wrapperClassName: 'org-inactive-notifications-email-quote-image',
  cropper: {
    outputWidth: 500,
    outputHeight: 500,
    renderWidth: 250,
    renderHeight: 250,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const protrackLevelImageMinSize = {
  width: 240,
  height: 240,
}

export const protrackLevelImageInputProps = {
  title: 'Image',
  entityName: 'image',
  minSize: protrackLevelImageMinSize,
  wrapperClassName: 'protrack-level-image',
  cropper: {
    outputWidth: 240,
    outputHeight: 240,
    renderWidth: 240,
    renderHeight: 240,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const activityImageMinSize = {
  width: 500,
  height: 500,
}

export const activityImageInputProps = {
  entityName: 'image',
  minSize: activityImageMinSize,
  wrapperClassName: 'activity-image',
  cropper: {
    outputWidth: 500,
    outputHeight: 500,
    renderWidth: 250,
    renderHeight: 250,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const orgMainLogoImageInputProps = {
  title: 'Main Logo',
  entityName: 'logo',
  minSize: {
    width: 360,
    height: 118,
  },
  wrapperClassName: 'organization-form-logo',
  cropper: {
    outputWidth: 180,
    outputHeight: 59,
    renderWidth: 180,
    renderHeight: 59,
    scale: {
      min: 25,
      max: 200,
    },
  },
}

export const orgEmailLogoImageInputProps = {
  title: 'Logo for Emails',
  entityName: 'logo',
  wrapperClassName: 'organization-form-logo',
}

export const proTrackLevelWelcomeEmailInputProps = {
  entityName: 'image',
  title: 'Welcome Email or Landing Page Image',
  minSize: {
    width: 500,
    height: 500,
  },
  wrapperClassName: 'protrack-level-form__email-image-input',
  cropper: {
    outputWidth: 500,
    outputHeight: 500,
    renderWidth: 250,
    renderHeight: 250,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const proTrackLevelFinishEmailInputProps = {
  entityName: 'image',
  title: 'Finish Email Image',
  minSize: {
    width: 500,
    height: 500,
  },
  wrapperClassName: 'protrack-level-form__email-image-input',
  cropper: {
    outputWidth: 500,
    outputHeight: 500,
    renderWidth: 250,
    renderHeight: 250,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const activityVideoInputProps = {
  entityName: 'video',
  minSize: {
    width: 200,
    height: 120,
  },
  wrapperClassName: 'activity-video',
  cropper: {
    outputWidth: 500,
    outputHeight: 500,
    renderWidth: 250,
    renderHeight: 250,
    scale: {
      min: 50,
      max: 200,
    },
  },
}

export const reviewsMessagingProps = {
  entityName: 'image',
  title: i18next.t('Reviewer Invitation image'),
  minSize: {
    width: 500,
    height: 500,
  },
  wrapperClassName: 'activity-image',
  cropper: {
    outputWidth: 500,
    outputHeight: 500,
    renderWidth: 250,
    renderHeight: 250,
    scale: {
      min: 50,
      max: 200,
    },
  },
}
